import { Product } from "@/api/product-api";
import { Accessories } from "@/components/tactsuit/components/buy-tactsuit/Accessories";
import { Accessory } from "@/store/useBuyTactSuit";
import { useState } from "react";
import ChevronDownIcon from "@/v2-components/core/icon/chevron-down-icon";
import ChevronUpIcon from "@/v2-components/core/icon/chevron-up-icon";
import { useTrans } from "@/utils/useTrans";

const VISIBLE_COUNT = 3;

export function BadgesSelect({
  accessories,
  selectedAccessories,
  onChange,
}: {
  selectedAccessories: Accessory[];
  onChange: (selected: Accessory) => void;
  accessories: Product[];
}) {
  const { t } = useTrans(["shop"]);
  const [expanded, setExpanded] = useState(false);
  const totalItems = accessories.reduce(
    (sum, p) => sum + p.skuOptions.length,
    0,
  );
  const hasMore = totalItems > VISIBLE_COUNT;

  return (
    <div>
      {/* 제목은 호출처 AccordionTrigger 가 갖는다 — 여기서 또 그리면 두 벌이 된다. */}
      <Accessories
        accessories={accessories}
        selectedAccessories={selectedAccessories}
        onChange={(item) => onChange({ ...item, type: "badge" })}
        maxVisibleItems={!expanded && hasMore ? VISIBLE_COUNT : undefined}
      />
      {hasMore && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="mt-3 flex w-full items-center justify-center gap-x-1 py-2 text-sm text-coolgray-70"
        >
          {expanded ? t("View Less") : t("View More")}
          {expanded ? (
            <ChevronUpIcon className="h-4 w-4" />
          ) : (
            <ChevronDownIcon className="h-4 w-4" />
          )}
        </button>
      )}
    </div>
  );
}
